// composables/useCart.js
import { ref, computed } from 'vue'

const items = ref(JSON.parse(localStorage.getItem('cart_items') || '[]'))
const totalPrice = ref(parseFloat(localStorage.getItem('cart_total_price') || '0'))

const addToCart = (productId, quantity = 1, maxStock = null,productPrice) => {
  const existingItem = items.value.find(item => item.product_id === productId)

  if (existingItem) {
    const newQuantity = existingItem.quantity + quantity

    if (maxStock !== null && newQuantity > maxStock) {
      return { success: false, message: 'موجودی کافی نیست' }
    }

    existingItem.quantity = newQuantity
  } else {
    if (maxStock !== null && quantity > maxStock) {
      return { success: false, message: 'موجودی کافی نیست' }
    }

    items.value.push({ product_id: productId, quantity,price: productPrice})
  }

  localStorage.setItem('cart_items', JSON.stringify(items.value))
    recalcTotal()
  return { success: true }
}

const saveTotalPrice = () => {
  localStorage.setItem('cart_total_price', totalPrice.value)
}

// محاسبه مجدد جمع کل بر اساس items
const recalcTotal = () => {
  totalPrice.value = items.value.reduce(
    (sum, item) => sum + (item.price * item.quantity || 0),
    0
  )
  saveTotalPrice()
}

// بررسی اینکه محصول در سبد هست یا نه
const isInCart = (productId) => {
  return items.value.some(item => item.product_id === productId)
}

const totalCount = computed(() => {
  return items.value.reduce((total, item) => total + item.quantity, 0)
})

export function useCart() {
  return { items, addToCart, isInCart, totalCount, removeFromCart, totalPrice, clearCart}
}


const removeFromCart = (productId) => {
  const itemIndex = items.value.findIndex(
    item => item.product_id === productId
  )

  if (itemIndex === -1) {
    return {
      success: false,
      message: 'محصول در سبد خرید وجود ندارد'
    }
  }

  items.value.splice(itemIndex, 1)

  localStorage.setItem('cart_items', JSON.stringify(items.value))
    recalcTotal()

  return {
    success: true
  }
}


const clearCart = () => {
  items.value = []
  totalPrice.value = 0
  localStorage.removeItem('cart_items')
  localStorage.removeItem('cart_total_price')

  return { success: true }
}


